import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bf4f290"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "image-area" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "button-area" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 무료 조회하기 ")

import { ref, onBeforeMount } from 'vue' 
import { useRoute } from 'vue-router';

import { BannerProps } from '@/api/landing';
import Text from '@/components/common/TextComponent.vue'
import XMark from '@/styles/icon/XMark.vue'
import { COLOR_SET } from '@/styles/variables'
import toRefund from '@/utils/toRefund'


export default /*#__PURE__*/_defineComponent({
  name: 'BannerTemplate',
  props: {
    banner: null
  },
  setup(__props: any) {

const props = __props as {
  banner: BannerProps;
}



const route = useRoute()
const isClose = ref(false)
const isHide = ref(true)

const handleClose = () => {
  isClose.value = true
}

const handleClick = () => {
  const { click_link } = props.banner
  if (click_link.includes('select-entity')) {
    toRefund()
  } else {
    window.open(click_link, '_self')
  }
}

const animationEnd = () => {
  if (isClose.value) {
    isHide.value = true
  }
}

const isAlways = () => {
  const { utm_campaign, utm_medium, utm_content, utm_source } = props.banner
  if (utm_campaign === null && utm_medium === null && utm_content === null && utm_source === null) {
    return true
  }
  return false
}

const isTargetUtm = () => {
  const { utm_campaign, utm_medium, utm_content, utm_source } = route.query

  if (utm_campaign?.includes(props.banner.utm_campaign) || utm_medium?.includes(props.banner.utm_medium) || utm_content?.includes(props.banner.utm_content) || utm_source?.includes(props.banner.utm_source)) {
    return true
  }
}

onBeforeMount(() => {
  if (isAlways() || isTargetUtm()) {
    isHide.value = false
  }
})

return (_ctx: any,_cache: any) => {
  return (!isHide.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["contents", { close: isClose.value }]),
            style: _normalizeStyle({ backgroundColor: __props.banner.image_background_color }),
            onAnimationend: animationEnd
          }, [
            _createElementVNode("div", {
              class: "header",
              onClick: handleClose
            }, [
              _createVNode(XMark, {
                size: "16px",
                color: _unref(COLOR_SET).white
              }, null, 8, ["color"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: __props.banner.image,
                width: "327",
                height: "327"
              }, null, 8, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "button",
                onClick: handleClick
              }, [
                _createVNode(Text, {
                  size: "18px",
                  weight: "600",
                  color: _unref(COLOR_SET).white
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["color"])
              ])
            ])
          ], 38),
          _createElementVNode("div", {
            class: "overlay",
            onClick: handleClose
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})